import styled from "styled-components";

export default styled.section`
    height: ${props => props.full ? "100vh" : "50vh"};

    @media (min-width: 768px) {
          height: 100vh;
      }
`;